import script from "./HomeTopCarouselComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeTopCarouselComponent.vue?vue&type=script&setup=true&lang=js"

import "./HomeTopCarouselComponent.vue?vue&type=style&index=0&id=563bbebe&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-563bbebe"]])

export default __exports__